<template>
    <div v-loading="loading">
        <side-menu v-if="$route.path !== '/auth' && $route.path !== '/policy'"></side-menu>
        <page-header v-if="passPath.indexOf($route.path) === -1 && $route.path !== '/policy'"></page-header>
        <router-view/>
    </div>

</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import AuthMixins from "@/mixins/AuthMixins";
import AlarmListModal from "@/components/modal/AlarmListModal.vue";
import EventBus from "@/utils/event-bus";

export default {
    name: "App",
    mixins: [alertMixins, AuthMixins],
    components: {
        AlarmListModal,
    },
    provide() {
        return {
        }
    },
    props: {},
    data() {
        return {
            passPath: ['/auth'],
            loading: false,
        }
    },
    created() {
        this.$store.dispatch('nticketCategory/setNticketCategory', {});
        this.$store.dispatch('competitionCategory/setCompetitionCategory', {});

    },
    mounted() {
        EventBus.$on('apiLoading', this.changeLoading)
    },
    beforeUnmount() {
        EventBus.$off('apiLoading')
    },
    unmounted() {
    },
    computed: {},
    methods: {
        changeLoading(value) {
            this.loading = value;
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve(true);
                }, 50)
            })
        },



    },
    watch: {},
}
</script>

<style lang="scss">
@import "./assets/scss/index.scss";

</style>
